<div class="d-flex justify-content-center" style="padding-left: 20%; padding-right: 20%;">
	<div class="card" style="width: 100%;">
		<div class="card-body d-flex flex-column" style="height: 90vh;">
			<h5 class="card-title text-center">End User License Agreement</h5>

			<iframe [src]="getUrl(pdfUrl) | safe:'resourceUrl'" class="flex-grow-1 border-0"></iframe>

			<div class="d-flex align-items-center justify-content-center">
				<input type="checkbox" id="eulaCheckbox" [checked]="agreed()" (change)="agreed.set($event.target.checked)" style="width: auto; transform: scale(1.2);" />
				<label for="eulaCheckbox" class="ms-2 mt-2" style="font-size: 18px; user-select: none; padding-left: 5px;">
					I accept this EULA
				</label>
			</div>

			<div class="d-flex justify-content-center mt-2">
				<button class="btn btn-primary btn-sm" style="width: 23%;" [disabled]="!agreed()" (click)="confirmEula()">
					Agree
				</button>
			</div>
		</div>
	</div>
</div>
